module.exports = __webpack_public_path__ + "static/img/3-info-b1.e6189b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-info-b1.jpg
// module id = F0uX
// module chunks = 0